var _require = require('./library'),
  get = _require.get,
  withMinAndMaxMedia = _require.withMinAndMaxMedia,
  makeErrorMessage = _require.makeErrorMessage;
exports.makeStyledBreakpoints = function (options) {
  var _options = options || {};
  var state = {
    pathToMediaQueries: _options.pathToMediaQueries || ['breakpoints'],
    errorPrefix: _options.errorPrefix || '[styled-breakpoints]: ',
    defaultMediaQueries: _options.defaultMediaQueries || {
      tablet: '768px',
      desktop: '992px',
      lgDesktop: '1200px'
    },
    browserContext: 16,
    invariant: function invariant(condition, message) {
      if (!condition) {
        throw new Error(state.errorPrefix + message);
      }
    },
    throwInvalidBreakValue: function throwInvalidBreakValue(breaks) {
      Object.keys(breaks).forEach(function (x) {
        state.invariant(x.indexOf('px') !== -1, "Check your theme. '".concat(breaks[x], "' is invalid breakpoint. Use pixels."));
      });
    },
    throwIsInvalidBreakName: function throwIsInvalidBreakName(breakName, breaks) {
      state.invariant(breaks[breakName], makeErrorMessage(breakName, breaks));
    },
    throwIsLastBreak: function throwIsLastBreak(breakName, breaks) {
      var names = Object.keys(breaks);
      var penultimateBreakName = names[names.length - 2];
      var isValid = names.indexOf(breakName) !== names.length - 1;
      state.invariant(isValid, "Don't use '".concat(breakName, "' because it doesn't have a maximum width. Use '").concat(penultimateBreakName, "'. See https://github.com/mg901/styled-breakpoints/issues/4 ."));
    },
    throwIsInvalidNextBreakValue: function throwIsInvalidNextBreakValue(name, breaks) {
      state.invariant(breaks[name], "'".concat(name, "' is invalid breakpoint name. Use '").concat(Object.keys(breaks).slice(0, -1).join(', '), "'."));
    },
    throwIsInvalidOrientation: function throwIsInvalidOrientation(x) {
      state.invariant(x === 'portrait' || x === 'landscape', "'".concat(x, "' is invalid orientation. Use 'landscape' or 'portrait'."));
    },
    withOrientationOrNot: function withOrientationOrNot(x, y) {
      if (y) {
        state.throwIsInvalidOrientation(y);
        return "".concat(x, " and (orientation: ").concat(y, ")");
      }
      return x;
    },
    toEm: function toEm(x) {
      return "".concat(parseFloat(x) / state.browserContext, "em");
    },
    getBreakpointsFromTheme: function getBreakpointsFromTheme(theme) {
      return get(state.pathToMediaQueries, theme, state.defaultMediaQueries);
    },
    getNextBreakpointName: function getNextBreakpointName(name) {
      return function (breaks) {
        state.throwIsInvalidBreakName(name, breaks);
        state.throwIsLastBreak(name, breaks);
        var names = Object.keys(breaks);
        return names[names.indexOf(name) + 1];
      };
    },
    // Maximum breakpoint width. Null for the largest (last) breakpoint.
    // The maximum value is calculated as the minimum of the next one less 0.02px
    // to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.
    // See https://www.w3.org/TR/mediaqueries-4/#mq-min-max
    // Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
    // See https://bugs.webkit.org/show_bug.cgi?id=178261
    getNextBreakpointValue: function getNextBreakpointValue(name, breaks) {
      state.throwIsInvalidNextBreakValue(name, breaks);
      var getNextName = state.getNextBreakpointName(name);
      return "".concat(parseFloat(breaks[getNextName(breaks)]) - 0.02, "px");
    },
    getBreakpointValue: function getBreakpointValue(name, breaks) {
      state.throwIsInvalidBreakName(name, breaks);
      return breaks[name];
    },
    calcMinWidth: function calcMinWidth(name, theme) {
      return state.toEm(state.getBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
    },
    calcMaxWidth: function calcMaxWidth(name, theme) {
      return state.toEm(state.getNextBreakpointValue(name, state.getBreakpointsFromTheme(theme)));
    },
    up: function up(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot("@media (min-width: ".concat(state.calcMinWidth(name, props.theme), ")"), orientation);
      };
    },
    down: function down(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot("@media (max-width: ".concat(state.calcMaxWidth(name, props.theme), ")"), orientation);
      };
    },
    between: function between(min, max, orientation) {
      return function (props) {
        return state.withOrientationOrNot(withMinAndMaxMedia(state.calcMinWidth(min, props.theme), state.calcMaxWidth(max, props.theme)), orientation);
      };
    },
    only: function only(name, orientation) {
      return function (props) {
        return state.withOrientationOrNot(withMinAndMaxMedia(state.calcMinWidth(name, props.theme), state.calcMaxWidth(name, props.theme)), orientation);
      };
    }
  };
  return state;
};